// Mock data for the public Build showcase page.
// Build: Liberty Walk × Kaido Works — Nissan Skyline R32 GT-R "QUADRANT 13"
//
// Liberty Walk Kaido Works wide-body Skyline running the Quadrant team livery.
// Signature look: full FRP overfenders with hand-set rivets, swan-neck GT
// wing, full motorsport-spec front splitter + rear diffuser, gloss-black SSR
// Professor SP4 wheels on Yokohama Advan tyres.

const R32_HERO_FRONT     = '/r32/hero-front-cherry.jpg';     // cherry blossom front 3/4 — primary hero
const R32_HERO_NIGHT     = '/r32/hero-night-highway.jpg';    // shutoko night tracking shot
const R32_HERO_REAR      = '/r32/hero-rear-3q.jpg';          // rear 3/4 with GT wing visible
const R32_HERO_GARAGE    = '/r32/hero-front-garage.jpg';     // street front 3/4, garage door bg
const R32_HERO_PADDOCK   = '/r32/hero-paddock.jpg';          // F1 paddock front 3/4
const R32_HERO_WAREHOUSE = '/r32/hero-warehouse.jpg';        // red-lit warehouse, headlights on
const R32_HERO_SUNSET    = '/r32/hero-sunset-street.jpg';    // sunset street front 3/4
const R32_DTL_HEADLIGHT  = '/r32/detail-headlight.jpg';      // close-up headlight, red warehouse
const R32_DTL_DIFFUSER   = '/r32/detail-rear-diffuser.jpg';  // rear "13" + diffuser blades
const R32_DTL_SIDE       = '/r32/detail-side-skirt.jpg';     // side #13 livery + skirt strake
const R32_DTL_HOOD       = '/r32/detail-front-hood.jpg';     // front fender + hood up + intercooler
const R32_DTL_FENDER     = '/r32/detail-fender-flare.jpg';   // door + fender flare + Liqui Moly
const R32_DTL_WING       = '/r32/detail-rear-wing.jpg';      // swan-neck GT wing close-up

export const build = {
  id: 213,
  title: 'Skyline',
  make: 'Nissan',
  model: 'R32 GT-R',
  year: 1990,
  buildName: 'LB × KAIDO WORKS — QUADRANT 13',
  status: 'LB-WORKS WIDEBODY',
  buildType: 'Show + Street + Shutoko',
  summaryTitle: 'Kaido Racer Build',
  summary: 'Liberty Walk × Kaido Works wide-body R32 GT-R built around shutoko-spec presence — maxed FRP overfenders, swan-neck GT wing, and the full Quadrant Team #13 livery.',
  bestFor: 'Show + spirited street',
  tags: ['R32', 'GTR', 'LibertyWalk', 'KaidoWorks', 'Quadrant', 'Widebody', 'RB26', 'Advan'],
  owner: {
    name: 'Stan Smith',
    handle: '@stan.builds',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
    followers: 42300,
    builds: 3,
    verified: true,
  },
  date: 'Published Apr 23, 2026',
  stats: { likes: 6420, comments: 318, saves: 2104, views: 84_560 },
  highlights: [
    { label: 'Widebody', delta: 'LB Kaido Works', icon: 'flame' },
    { label: 'Aero',     delta: 'Swan-neck GT',   icon: 'wing'  },
    { label: 'Stance',   delta: '-3.5" drop',     icon: 'low'   },
    { label: 'Built',    delta: 'By Liberty Walk',icon: 'star'  },
  ],
  // Build Score sits FIRST and renders with a distinct hero-card design.
  // The other 4 are the standard performance KPIs.
  kpis: [
    { label: 'Build Score', value: 9.4,  unit: '/ 10',   subLabel: 'from 218 community votes', delta: 'TOP 2%', icon: 'award', kind: 'score' },
    { label: 'Horsepower',  value: 480,  unit: 'hp',     stock: 276,  delta: '+204', icon: 'gauge' },
    { label: 'Torque',      value: 440,  unit: 'lb-ft',  stock: 271,  delta: '+169', icon: 'torque' },
    { label: '0 – 60',      value: 4.1,  unit: 'sec',    stock: 5.4,  delta: '-1.3', icon: 'stopwatch', inverse: true },
    { label: 'Top Speed',   value: 188,  unit: 'mph',    stock: 156,  delta: '+32',  icon: 'speed' },
  ],
  // Main gallery — 13 hero stills covering every angle
  gallery: [
    { type: 'image', src: R32_HERO_FRONT,     label: 'Front 3/4 · Sakura' },
    { type: 'image', src: R32_HERO_GARAGE,    label: 'Front 3/4 · Garage' },
    { type: 'image', src: R32_HERO_SUNSET,    label: 'Front 3/4 · Sunset' },
    { type: 'image', src: R32_HERO_PADDOCK,   label: 'Front 3/4 · F1 Paddock' },
    { type: 'image', src: R32_HERO_WAREHOUSE, label: 'Front 3/4 · Warehouse' },
    { type: 'image', src: R32_HERO_NIGHT,     label: 'Shutoko · night run' },
    { type: 'image', src: R32_HERO_REAR,      label: 'Rear 3/4 · GT wing' },
    { type: 'image', src: R32_DTL_SIDE,       label: 'Side profile · #13' },
    { type: 'image', src: R32_DTL_DIFFUSER,   label: 'Rear · Diffuser' },
    { type: 'image', src: R32_DTL_WING,       label: 'Rear · Swan-neck wing' },
    { type: 'image', src: R32_DTL_HOOD,       label: 'Front detail · Hood up' },
    { type: 'image', src: R32_DTL_FENDER,     label: 'Fender · Flare' },
    { type: 'image', src: R32_DTL_HEADLIGHT,  label: 'Detail · Headlight' },
  ],
  // Hotspots placed over the FIRST gallery item (cherry-blossom front 3/4).
  // Car is oriented front-right-facing; nose lower-right, wing upper-left.
  heroHotspots: [
    { id: 'hh1', x: 22, y: 38, partId: 'p-wing' },     // GT wing visible upper-left over body
    { id: 'hh2', x: 32, y: 80, partId: 'p-wheels' },   // black wheel (lower-left)
    { id: 'hh3', x: 50, y: 70, partId: 'p-skirt' },    // widebody fender flare mid
    { id: 'hh4', x: 78, y: 88, partId: 'p-splitter' }, // front splitter (bottom-right)
  ],
  // DIFFERENT image + different hotspots for the Tagged Products tab.
  // Side-profile shot: nose right, wing/rear left.
  taggedImage: R32_DTL_SIDE,
  taggedHotspots: [
    { id: 'th1', x: 18, y: 58, partId: 'p-skirt' },     // side skirt strake
    { id: 'th2', x: 80, y: 68, partId: 'p-wheels' },    // rear wheel
    { id: 'th3', x: 50, y: 30, partId: 'p-wing' },      // wing visible top
    { id: 'th4', x: 35, y: 78, partId: 'p-coilovers' }, // lowered stance
    { id: 'th5', x: 64, y: 85, partId: 'p-brembo' },    // rear brake area
  ],
  // Tagged Products gallery — curated 6 views where part-tagging actually works.
  // Container aspect now matches source images (3:2), so hotspot (x, y) percentages
  // map 1:1 to source-image positions identified via vision analysis.
  taggedGallery: [
    {
      id: 'tv-front-sakura',
      label: 'Front 3/4 · Sakura',
      image: R32_HERO_FRONT,
      hotspots: [
        { id: 'tv-fs-1', x: 42, y: 69, partId: 'p-skirt' },     // front fender-flare bulge
        { id: 'tv-fs-2', x: 38, y: 78, partId: 'p-wheels' },    // front wheel
        { id: 'tv-fs-3', x: 66, y: 84, partId: 'p-splitter' },  // front splitter / lip
      ],
    },
    {
      id: 'tv-side',
      label: 'Side · #13 livery',
      image: R32_DTL_SIDE,
      hotspots: [
        { id: 'tv-side-1', x: 50, y: 82, partId: 'p-skirt' },   // "quadrant" side strake panel
        { id: 'tv-side-2', x: 88, y: 60, partId: 'p-wheels' },  // wheel + Advan tire visible right side
      ],
    },
    {
      id: 'tv-fender',
      label: 'Fender flare',
      image: R32_DTL_FENDER,
      hotspots: [
        { id: 'tv-fender-1', x: 75, y: 50, partId: 'p-skirt' },  // FRP fender flare bulge
        { id: 'tv-fender-2', x: 78, y: 68, partId: 'p-wheels' }, // wheel/tire in arch
      ],
    },
    {
      id: 'tv-rear',
      label: 'Rear · Diffuser',
      image: R32_DTL_DIFFUSER,
      hotspots: [
        { id: 'tv-rear-1', x: 50, y: 78, partId: 'p-splitter' }, // rear diffuser blades
      ],
    },
    {
      id: 'tv-rear-wing',
      label: 'Rear · Swan-neck wing',
      image: R32_DTL_WING,
      hotspots: [
        { id: 'tv-rw-1', x: 48, y: 41, partId: 'p-wing' },       // wing aerofoil center
      ],
    },
    {
      id: 'tv-hood',
      label: 'Front detail · Hood up',
      image: R32_DTL_HOOD,
      hotspots: [
        { id: 'tv-hd-1', x: 57, y: 50, partId: 'p-fuel' },       // intercooler in bumper opening
        { id: 'tv-hd-2', x: 55, y: 80, partId: 'p-splitter' },   // front splitter
      ],
    },
  ],
};

export const overview = {
  description:
    "This build leans hard into the kaido racer aesthetic — full Liberty Walk × Kaido Works wide aero, Quadrant Team #13 livery, and a freshly refreshed RB26DETT pushing 480 whp. Built for shutoko presence first, time-attack credibility second.",
  ownerInsights:
    "The car has the road manners of a modern GT car and the visual punch of a Group A homologation special. Throttle response from the Tomei turbos is sharp, AWD pull off corners is brutal, and the FRP wide aero turns every car park into a meet.",
  goals: [
    'Achieve full LB × Kaido Works wide-body presence',
    'Push RB26DETT to a reliable 480 whp on E85',
    'Keep the chassis shutoko-stable above 250 km/h',
  ],
  discussions: 18,
  journey: [
    { stage: 'Stage 1', label: 'Wide aero + livery' },
    { stage: 'Stage 2', label: 'RB26 refresh + Tomei turbos' },
    { stage: 'Stage 3', label: 'Suspension + AWD tune' },
  ],
  timeline: [
    { month: 'Sep 2023', label: 'Sourced clean RHD R32 GT-R — Nagoya' },
    { month: 'Jan 2024', label: 'Chassis delivered to Liberty Walk HQ' },
    { month: 'Apr 2024', label: 'Kaido Works full FRP wide aero fitted' },
    { month: 'Sep 2024', label: 'RB26DETT refresh + Tomei ARMS turbos' },
    { month: 'Mar 2025', label: 'Quadrant Team #13 livery applied' },
    { month: 'Apr 2025', label: 'Debut — F1 Japanese GP, Suzuka' },
  ],
};

export const systems = [
  { id: 'engine',     name: 'Engine & Power',      icon: 'Gauge',      partCount: 4, rating: 4.8, trust: 'proven' },
  { id: 'intake',     name: 'Intake & Exhaust',    icon: 'Wind',       partCount: 3, rating: 4.8, trust: 'proven' },
  { id: 'fuel',       name: 'Fuel & Cooling',      icon: 'Fuel',       partCount: 2, rating: 4.7, trust: 'conditional' },
  { id: 'drivetrain', name: 'Drivetrain',          icon: 'Cog',        partCount: 2, rating: 4.8, trust: 'proven' },
  { id: 'suspension', name: 'Suspension',          icon: 'Waves',      partCount: 5, rating: 5.0, trust: 'proven' },
  { id: 'wheels',     name: 'Wheels & Tires',      icon: 'CircleDot',  partCount: 2, rating: 5.0, trust: 'proven' },
  { id: 'brakes',     name: 'Brakes',              icon: 'Disc',       partCount: 2, rating: 4.8, trust: 'proven' },
  { id: 'aero',       name: 'Aerodynamics',        icon: 'Plane',      partCount: 6, rating: 5.0, trust: 'proven' },
  { id: 'exterior',   name: 'Exterior',            icon: 'Sparkles',   partCount: 3, rating: 4.9, trust: 'proven' },
  { id: 'interior',   name: 'Interior',            icon: 'Armchair',   partCount: 3, rating: 4.7, trust: 'proven' },
  { id: 'tuning',     name: 'Electronics & Tuning',icon: 'Cpu',        partCount: 1, rating: 4.6, trust: 'conditional' },
];

export const breakdown = {
  aero: {
    summary:
      'The full Liberty Walk × Kaido Works treatment: hand-laid FRP overfenders with riveted lips, motorsport-spec front splitter + canards, side strakes, GT-style rear diffuser, and a swan-neck GT wing. Fitted at Liberty Walk HQ in Nagoya.',
    pros: ['Unmistakable LB × Kaido Works silhouette', 'Widens the track +75mm per side', 'Each kit is hand-trimmed and riveted on-car'],
    cons: ['Fitment takes 4+ weeks of shop time', 'FRP edges chip if not ceramic-coated'],
    rating: 5.0, buildersUsing: 286, trust: 'proven',
    sections: {
      performanceImpact: 'Wider track gives measurably more grip mid-corner. The swan-neck wing produces real rear downforce above 180 km/h.',
      drivingExperience: 'It is a presence car — every approach is a moment. The aero load also calms the chassis at shutoko speeds.',
      reliability: 'Bolted FRP panels outlast factory fenders if cared for. Re-check rivet seats every 10,000 km.',
      installSetup: 'Only Liberty Walk Nagoya or a licensed Kaido Works fitter should attempt this. 100+ labour hours, cutting + bolting + paint + livery.',
      thingsToKnow: 'Do not ship the kit to a local body shop. Each rivet is hand-placed and the original fender is cut to commit the chassis.',
      comparison: 'Pandem Rocket Bunny is aggressive and cleaner; LB × Kaido Works is the louder, riveted, decal-heavy bosozoku-meets-Group-A version.',
      recommendations: [
        'Only commission a licensed Liberty Walk fitter — never a local body shop',
        'Have the gloss white paint matched and ceramic-coated before livery is applied',
        'Inspect rivets every 10,000 km to check for shop-fit movement',
      ],
    },
  },
  suspension: {
    summary: 'HKS Hipermax IV SP coilovers, Cusco front + rear sway bars, full Nismo poly-bushing kit. Drops the R32 by 90 mm while keeping the AWD chassis composed at speed.',
    pros: ['Damping range works on bumpy shutoko tarmac', 'AWD chassis stays planted under power', 'Massive cornering balance gain over stock'],
    cons: ['Corner-balance required after install', 'Front fender roll mandatory to clear the Advans'],
    rating: 5.0, buildersUsing: 312, trust: 'proven',
    sections: {
      performanceImpact: 'Stiffer roll bars + lowered CG cut body roll roughly in half. Skidpad up over 20% versus a stock GT-R.',
      drivingExperience: 'The R32 finally feels like a modern AWD platform. Turn-in is instant and the rear stays flat under throttle.',
      reliability: 'Hipermax IV SP have a 60,000 km service interval. Cusco bars are lifetime parts. Excellent long-term return.',
      installSetup: '14 shop hours. Corner-balance + 4-wheel alignment mandatory ($500). Fender roll if running 295-section rear rubber.',
      thingsToKnow: 'Start at HKS recommended click setting and only stiffen 2-3 clicks. The R32 ATTESA system rewards damping consistency.',
      comparison: 'Tein Mono Sport is cheaper and harsher; Aragosta Type-S is sharper but stiffer. Hipermax IV SP is the daily-and-shutoko sweet spot.',
      recommendations: [
        'Pair Hipermax IV SP with adjustable Cusco swaybars for a balanced front-rear setup',
        'Budget $500 for a proper corner-balance + 4-wheel alignment after install',
        'Start at the HKS recommended click setting and stiffen only 2–3 clicks at a time',
      ],
    },
  },
  wheels: {
    summary: 'Gloss-black SSR Professor SP4 3-piece — 18×10 -8 front, 18×11 -15 rear — wrapped in Yokohama Advan A052 R-compound semi-slick.',
    pros: ['Deep-dish stance fills the LB widebody perfectly', 'Forged 3-piece keeps unsprung weight low', 'A052 grip transforms cornering load'],
    cons: ['A052 wears fast in street use', 'Gloss-black face shows every kerb scuff'],
    rating: 5.0, buildersUsing: 487, trust: 'proven',
    sections: {
      performanceImpact: 'Contact patch is huge. Lateral grip is up roughly 20% versus a clean OEM Bridgestone setup.',
      drivingExperience: 'You can feel the tyre bite. Steering loads up beautifully and the AWD bites instantly off corner.',
      reliability: 'Professor SP4 wheels are hand-built and bulletproof. A052 will need replacement every 12,000-15,000 km if driven hard.',
      installSetup: 'Must match LB widebody fitment — offset and width are spec-critical. 3-piece construction allows custom offsets.',
      thingsToKnow: 'A052 is not a wet tyre. Keep a second set of wheels on Advan Neova AD09 for rain.',
      comparison: 'Work Equip 03 is the closest aesthetic alternative; Volk TE37 Ultra is lighter but the wrong silhouette for a kaido racer.',
      recommendations: [
        'Ceramic-coat the gloss-black face within the first month to keep it deep',
        'Keep a second wet-set of Advan Neova — A052 is unsafe in cold/wet',
        'Re-torque to 18 lb-ft at 500 km after install (3-piece construction)',
      ],
    },
  },
  engine: {
    summary: 'RB26DETT refreshed with forged internals, Tomei ARMS M7960 twin-scroll turbos, billet timing kit, full coil-on-plug conversion. Tuned on E85.',
    pros: ['Reliable 480 whp on a refreshed bottom end', 'Twin-scroll spool is GT-R era-appropriate', 'Sound is unmistakable RB26'],
    cons: ['E85 fuel logistics on long road trips', 'Premium service-interval discipline required'],
    rating: 4.8, buildersUsing: 224, trust: 'proven',
    sections: {
      performanceImpact: '480 whp / 440 lb-ft vs 276/271 stock. Power band is wide — twin-scroll keeps boost on tap from 3,500 rpm.',
      drivingExperience: 'AWD launch is brutal. Mid-range pull is what you remember — the M7960s come on like a switch and never let off.',
      reliability: 'Forged internals are designed for 600+ whp; we are running them well under that ceiling.',
      installSetup: 'Tomei ARMS bolt to factory manifolds. Full motor refresh + turbo swap + tune is a 4-week shop job.',
      thingsToKnow: 'Run E85 only or a 50/50 E50 blend with proper map switching. Stay on top of oil changes (5,000 km).',
      comparison: 'Garrett G25 single is cheaper but loses the OEM-like response. M7960 twin is the modern enthusiast move on a daily-driveable GT-R.',
      recommendations: [
        'Tune at an HKS or Tomei certified RB specialist — never a generic dyno',
        'Run E85 as the primary fuel — never drop below E50 blend',
        'Change oil every 5,000 km regardless of mileage interval',
      ],
    },
  },
  brakes: {
    summary: 'Endless Mono 6R 6-piston front BBK, refreshed OEM rear Brembo, MX72 Plus pads, Endless braided lines, Motul RBF660 fluid.',
    pros: ['Zero fade over back-to-back shutoko runs', 'Looks correct behind the SP4 wheels', 'Pedal feel is firm and linear'],
    cons: ['MX72 Plus is dusty', '+9 lbs per corner versus OEM'],
    rating: 4.8, buildersUsing: 178, trust: 'proven',
    sections: {
      performanceImpact: '60-0 from 132 ft factory to 108 ft. Massive improvement thanks to bigger pads + A052 grip.',
      drivingExperience: 'Pedal is firm and predictable. You can brake deep into Daikoku off-ramps without hesitation.',
      reliability: 'Two-piece floating rotors after 18,000 km look perfect. Pads replaced once.',
      installSetup: 'Requires 18"+ wheels for caliper clearance (no issue here). 7 shop hours. Braided lines mandatory.',
      thingsToKnow: 'Bleed brakes annually. RBF660 absorbs moisture — stale fluid kills pedal feel fast.',
      comparison: 'Stock GT-R Brembos refreshed is 50% cheaper but cannot match Endless thermal capacity in summer.',
      recommendations: [
        'Bleed annually with fresh RBF660 — moisture is the silent killer of pedal feel',
        'Pair with MX72 Plus pads for the street/track sweet spot',
        'Verify 18" wheel caliper clearance before ordering the BBK',
      ],
    },
  },
  intake: { summary: 'HKS Racing Suction intake + HKS Hi-Power 304 stainless 3-inch cat-back exhaust, paired with Tomei manifolds.', pros: ['Sounds enormous on overrun', 'No drone at cruise'], cons: ['Cabin volume rises sharply above 5,000 rpm'], rating: 4.8, buildersUsing: 311, trust: 'proven', sections: { performanceImpact: '+38 whp from breathing alone after the turbo swap.', drivingExperience: 'RB26 turbo flutter and overrun crackle are loud and addictive.', reliability: 'Stainless holds up indefinitely.', installSetup: '5 hours for full bolt-on.', thingsToKnow: 'Heat-shielding the intake pipe is mandatory in summer.', comparison: 'Greddy Revolution is louder; HKS Hi-Power is the daily sweet spot.', recommendations: ['Heat-shield the HKS Racing Suction in summer to keep IATs sane', 'Re-oil the cone filter every 8,000 km', 'Keep factory under-tray to manage thermal load on the cat-back'] } },
  fuel: { summary: 'Sard 740cc top-feed injectors + Bosch 044 inline pump, paired with a stainless surge tank for E85 use.', pros: ['Required headroom for 480 whp on E85', 'Plug-and-play with HKS F-CON V Pro'], cons: ['E85 demands disciplined refuelling planning'], rating: 4.7, buildersUsing: 142, trust: 'conditional', sections: { performanceImpact: 'Enables safe AFR delivery at full boost on E85.', drivingExperience: 'Invisible upgrade — enables everything else.', reliability: 'Sard + Bosch components are overbuilt for 600+ whp.', installSetup: '5 hours with surge tank fabrication.', thingsToKnow: 'Drain and dose with fuel stabilizer if storing on E85 for >30 days.', comparison: 'ID1050 is cheaper but Sard 740cc is sized perfectly for this 480 whp tune.', recommendations: ['Always pair injectors with a fresh E85 map — never reuse pump-gas tune', 'Check for fuel leaks at the surge tank weekly for the first month', 'Use a wideband UEGO sensor to verify AFR after every refill'] } },
  drivetrain: { summary: 'OS Giken twin-plate clutch, lightened flywheel, Nismo GT pro-ring transfer case for the ATTESA E-TS AWD system.', pros: ['Handles the torque without slip', 'Sharper AWD response off-corner'], cons: ['Pedal effort is heavier than stock'], rating: 4.8, buildersUsing: 167, trust: 'proven', sections: { performanceImpact: 'Shift times down ~25%. AWD lockup is sharper through the Nismo transfer case.', drivingExperience: 'Engagement zone is narrow but precise. Launch is brutal.', reliability: '15,000 km, zero slip.', installSetup: '10 shop hours including transmission drop.', thingsToKnow: 'Bed the clutch in over 800 km before hard launches.', comparison: 'Triple-plate is overkill on a 480 whp street build. OS Giken twin is the right balance.', recommendations: ['Bed-in the clutch over 800 km of mixed driving before hard launches', 'Use Nismo GT-spec gearbox oil — never substitute generic synthetic', 'Avoid clutch dumps for the first 1,500 km to extend friction-disc life'] } },
  exterior: { summary: 'Gloss white single-stage paint, ceramic coated, full Quadrant Team #13 vinyl livery — Liqui Moly, Advan, BLASK, AK-Produce, Bride, SSR, Tone sponsors.', pros: ['Gloss-white paint pops against the black wheels', 'Livery is reversible vinyl, not paint', 'Ceramic protects 3+ years'], cons: ['White shows every fingerprint and brake-dust mark'], rating: 4.9, buildersUsing: 198, trust: 'proven', sections: { performanceImpact: 'Cosmetic only.', drivingExperience: 'The livery is the car.', reliability: 'Ceramic + premium vinyl holds up well. Hand wash only.', installSetup: '6 days in paint booth + 2 days for livery wrap.', thingsToKnow: 'No automatic car washes — ever. Hand wash with two-bucket method.', comparison: 'Full custom paint livery is twice the cost and not reversible. Vinyl is the smart-money path.', recommendations: ['Hand wash only — automatic car washes will scratch the ceramic and lift vinyl edges', 'Re-coat ceramic every 3 years to maintain protection', 'Use only pH-neutral car shampoo and a soft microfibre mitt'] } },
  interior: { summary: 'Bride Stradia II Low Max bucket seats, Nardi Classic 350 mm wood wheel, custom carbon centre console, Recaro 4-point harnesses, full bolt-in roll cage.', pros: ['Period-correct kaido racer aesthetic', 'Bride Low Max gives modern lateral support', 'Cage adds chassis stiffness'],  cons: ['Cage makes rear seat unusable'], rating: 4.7, buildersUsing: 156, trust: 'proven', sections: { performanceImpact: 'Cage adds measurable chassis stiffness on shutoko transitions.', drivingExperience: 'Hold-you-flat seats + thin-rim wood wheel = pure analogue driving focus.', reliability: 'Bride and Nardi components are bulletproof.', installSetup: '6 hours for seats + harnesses, 2 days for the bolt-in cage.', thingsToKnow: 'Cage is bolt-in, not welded — fully reversible if you sell the car.', comparison: 'Cusco cage is cheaper but the Saito-built bolt-in is built to JAF spec.', recommendations: ['Keep a microfibre in the car for the wood wheel — sweat ruins the finish', 'Use the Bride-spec FIA brackets — never improvise the seat mount', 'Re-torque cage bolts at 1,000 km after first install'] } },
  tuning: { summary: 'HKS F-CON V Pro standalone ECU mapping with full E85 tune, AEM UEGO wideband feedback, datalogged on a Mustang AWD dyno.', pros: ['Safe fuelling + ignition curve at 480 whp', 'Unlocks the ARMS turbo potential'], cons: ['Re-tune required if you change boost target'], rating: 4.6, buildersUsing: 134, trust: 'conditional', sections: { performanceImpact: 'Final +50 whp on top of the raw hardware gains.', drivingExperience: 'Smoother throttle curve, better idle stability with the new injectors.', reliability: 'Conservative tune — runs cool, lives long.', installSetup: 'Mustang AWD dyno session with an HKS-certified RB tuner.', thingsToKnow: 'Save the stock map as a backup — never lose it.', comparison: 'Generic AEM Infinity is cheaper but not RB-aware. F-CON V Pro is the safe, idiomatic choice.', recommendations: ['Tune in-person on an AWD dyno — never accept a remote RB tune', 'Save the OEM map in a labelled USB stick in the glovebox', 'Re-log AFR every 5,000 km to verify the map is still safe'] } },
};

// Parts catalog — reuses existing generated PNGs under /parts/
// Each part carries:
//   priceNum    → MSRP / sticker price for the product alone
//   pricePaidNum → what the owner actually paid all-in (product + labor + install)
//   installHrs  → shop hours to install (for context under "what you paid")
//   whyThisPart → short rationale (shows in product detail "Why this part")
//   specs       → quick tech spec table for product detail view
export const parts = [
  { id: 'p-wheels', system: 'wheels', name: 'Professor SP4 3-Piece', brand: 'SSR',
    priceNum: 7400, pricePaidNum: 8120, installHrs: 3, image: '/parts/p-wheels.png',
    rating: 5.0, reviews: 286, featured: true,
    note: 'The kaido-racer wheel. 18×10 -8 front / 18×11 -15 rear, gloss black. Fills the LB widebody flush.',
    whyThisPart: 'Only wheel that fills the LB × Kaido Works fenders correctly. Forged 3-piece keeps unsprung mass low at this width.',
    specs: { 'Size (F)': '18x10 ET -8', 'Size (R)': '18x11 ET -15', Finish: 'Gloss Black 3-piece', Weight: '20.4 lbs / 22.6 lbs', PCD: '5x114.3' },
    performance: 'Wider contact patch transforms lateral grip. Skidpad up roughly +20% versus factory Bridgestones.',
    install: '3 shop hours for mount + balance. TPMS sensors carried over. Fender roll done as part of the LB kit fitment.',
    thingsToKnow: 'Gloss-black face needs ceramic coat or it will dull within 18 months. Torque-spec on 3-piece bolts = 18 lb-ft; re-check at 500 km.',
  },
  { id: 'p-tires', system: 'wheels', name: 'Yokohama Advan A052 265/35 / 295/30', brand: 'Yokohama',
    priceNum: 1820, pricePaidNum: 2040, installHrs: 1, image: '/parts/p-tires.png',
    rating: 4.9, reviews: 1240,
    note: 'R-compound semi-slick. Serious dry grip. Not a wet tyre — keep a second set.',
    whyThisPart: 'Matches the SP4 sizing and is the de-facto JDM time-attack tyre. A052 reads the road like nothing else in this class.',
    specs: { Compound: 'R-compound semi-slick', 'Tread (F)': '265/35R18', 'Tread (R)': '295/30R18', 'Wear': 'Soft — 12-15k km', 'Wet rating': 'Poor' },
    performance: 'Lateral grip far above any UHP street tyre — the bite is immediate.',
    install: 'Mount + balance on 3-piece SP4 takes ~1 hour. Store with tyre covers if parked outdoors.',
    thingsToKnow: 'Keep a second wet-season set of Advan Neova AD09. A052 is unsafe below 10°C.',
  },
  { id: 'p-coilovers', system: 'suspension', name: 'HKS Hipermax IV SP', brand: 'HKS',
    priceNum: 4200, pricePaidNum: 5040, installHrs: 6, image: '/parts/p-coilovers.png',
    rating: 5.0, reviews: 184, featured: true,
    note: 'Drops the GT-R 90 mm while staying daily-driveable. The kaido-racer ride.',
    whyThisPart: 'HKS damper valving is calibrated for the R32 ATTESA chassis. Hipermax IV SP keeps the AWD platform composed at speed.',
    specs: { Type: '30-click adjustable monotube', 'Spring (F)': '14 kg/mm', 'Spring (R)': '12 kg/mm', 'Drop': '90 mm', Rebuild: '60,000 km' },
    performance: 'Lower CG + stiffer damping cuts body roll in half. Turn-in is instant and the rear stays planted under throttle.',
    install: '6 shop hours. Corner-balance + 4-wheel alignment required ($500) for the money to actually land.',
    thingsToKnow: 'Start at HKS recommended click setting. More is not better on an AWD GT-R chassis — it will skate.',
  },
  { id: 'p-arms', system: 'suspension', name: 'Adjustable Sway Bars F/R', brand: 'Cusco',
    priceNum: 940, pricePaidNum: 1180, installHrs: 2, image: '/parts/p-arms.png',
    rating: 4.9, reviews: 142,
    note: 'Front soft / rear stiff = neutral AWD balance through Daikoku transitions.',
    whyThisPart: 'Cheap, reversible, and the single biggest cornering-balance change you can make on a R32 GT-R.',
    specs: { 'Front bar': '28mm hollow 3-way', 'Rear bar': '24mm hollow 3-way', Bushings: 'Cusco poly', Material: '4140 chromoly' },
    performance: 'Neutralises the GT-R nose-heavy bias. Trail-braking suddenly works.',
    install: '2 hours. Re-grease bushings annually.',
    thingsToKnow: 'Soft-front / stiff-rear is the kaido-racer setup. Reverse it and the AWD pushes wide on corner entry.',
  },
  { id: 'p-turbo', system: 'engine', name: 'ARMS M7960 Twin-Scroll Turbos', brand: 'Tomei',
    priceNum: 5800, pricePaidNum: 7600, installHrs: 18, image: '/parts/p-turbo.png',
    rating: 4.9, reviews: 124, featured: true,
    note: 'Twin-scroll spool + OEM-like response. The smart-money RB26 turbo upgrade.',
    whyThisPart: 'Tomei ARMS keep the OEM twin-turbo character but unlock 480+ whp without losing low-end response.',
    usedInBuilds: 412,
    recommendPercent: 96,
    whatWorks: ['Twin-scroll spool feels OEM-tight', 'Bolt-on to factory exhaust manifolds', '+200 whp without major fabrication'],
    tradeOffs: ['Fuel system upgrade mandatory', 'E85 tune strongly recommended', 'Dyno tune adds $1.5k+ to total cost'],
    performance: 'Spool from 3,500 rpm. Mid-range pull is brutal and stays linear to 7,500 rpm.',
    drivingExperience: 'It feels like a modern AWD GT car off-corner. Boost arrives like a switch but never falls off.',
    reliability: 'Forged internals on the refreshed bottom end are rated for 600+ whp; we run well under that.',
    install: '18 hour install including motor pull. Must be dynoed on an HKS or Tomei certified tuner afterward.',
    thingsToKnow: 'Run E85 only or 50/50 blend with proper map switching. Premium oil every 5,000 km.',
    bestFor: ['Show + spirited street', 'Owners chasing OEM-like response over peak hp', 'Builders who want the period-correct twin-turbo aesthetic'],
  },
  { id: 'p-intake', system: 'intake', name: 'Racing Suction Intake', brand: 'HKS',
    priceNum: 540, pricePaidNum: 660, installHrs: 1.5, image: '/parts/p-intake.png',
    rating: 4.7, reviews: 218,
    note: 'Feeds the ARMS turbos cleanly. The HKS classic.',
    whyThisPart: 'A proper sealed airbox keeps engine-bay heat off the MAFs and looks period-correct under the hood.',
    specs: { Material: 'Aluminium piping + dry cone filter', Filter: 'Pleated dry cotton', 'Inlet': '80mm', Weight: '4.2 lbs' },
    performance: 'Cooler intake charge = +6-8 whp over the OEM box at full boost.',
    install: '1.5 hrs. Heat-shield the inlet pipe in summer.',
    thingsToKnow: 'Re-oil filter every 8,000 km. Heat-shield in summer or IATs spike fast.',
  },
  { id: 'p-exhaust', system: 'intake', name: 'Hi-Power 304 Cat-Back Exhaust', brand: 'HKS',
    priceNum: 2400, pricePaidNum: 2780, installHrs: 3, image: '/parts/p-exhaust.png',
    rating: 4.8, reviews: 318,
    note: 'Proper RB26 soundtrack — overrun crackle, no drone.',
    whyThisPart: '3-inch cat-back without being obnoxious at 100 km/h cruise. Period-correct HKS aesthetic.',
    specs: { Material: '304 stainless', 'Pipe size': '3.0"', Tips: 'Twin 4"', 'Sound': 'Mid-aggressive', 'Fitment': 'R32 GT-R only' },
    performance: '+20 whp from reduced backpressure paired with the ARMS turbos.',
    install: '3 hrs bolt-on. Pair with Tomei manifolds for full gain.',
    thingsToKnow: 'Keep factory under-tray for thermal management on long shutoko runs.',
  },
  { id: 'p-brembo', system: 'brakes', name: 'Endless Mono 6R 6-Pot BBK', brand: 'Endless',
    priceNum: 4800, pricePaidNum: 5640, installHrs: 5, image: '/parts/p-brembo.png',
    rating: 4.9, reviews: 168, featured: true,
    note: 'The right brakes for a 480 whp AWD R32. Looks correct behind the SP4 wheels.',
    whyThisPart: 'OEM Brembos overheat after back-to-back shutoko runs at this power level. Endless 6R holds up.',
    specs: { Caliper: '6-piston monoblock', Rotor: '370mm x 34mm 2-piece slotted', Pads: 'Endless MX72 Plus', Lines: 'Endless braided stainless' },
    performance: '60-0 from 132 ft stock to 108 ft. Zero fade after 6 hot stops.',
    install: '5 hrs. Requires 18"+ wheels for caliper clearance.',
    thingsToKnow: 'Bleed annually with RBF660. MX72 Plus is dusty — keep a brush in the car.',
  },
  { id: 'p-pads', system: 'brakes', name: 'MX72 Plus Pads', brand: 'Endless',
    priceNum: 320, pricePaidNum: 380, installHrs: 0.5, image: '/parts/p-pads.png',
    rating: 4.8, reviews: 124,
    note: 'Street-friendly, track-capable. Cold squeal is normal.',
    whyThisPart: 'The sweet-spot street / light-track pad for an Endless 6R caliper. Works cold, survives hot.',
    specs: { Compound: 'Low-metallic', 'Temp range': '50-700 °C', 'Rotor wear': 'Low', 'Dust': 'Medium-high' },
    performance: 'Linear bite from cold. Holds up through a full Daikoku-PA loop.',
    install: '30 mins per axle if the BBK is already fitted.',
    thingsToKnow: 'Cold squeal is normal for the first 300 km after swap — not a defect.',
  },
  { id: 'p-wing', system: 'aero', name: 'Swan-Neck GT Wing', brand: 'LB × Kaido Works',
    priceNum: 3600, pricePaidNum: 5240, installHrs: 14, image: '/parts/p-wing.png',
    rating: 5.0, reviews: 198, featured: true,
    note: 'The signature Liberty Walk swan-neck. Real downforce. Instant kaido-racer presence.',
    whyThisPart: 'The LB × Kaido Works signature. No substitute. Each is hand-fitted at Liberty Walk Nagoya HQ.',
    specs: { Span: '1620 mm', Profile: 'GT single-element swan-neck', Mount: 'Through-deck swan-neck uprights', Material: 'Hand-laid FRP + gel coat' },
    performance: 'Measurable rear downforce above 180 km/h. The chassis settles dramatically.',
    install: '14 hrs including deck reinforcement + paint-match + livery panels.',
    thingsToKnow: 'Do not ship this kit to a local body shop. Licensed Liberty Walk fitment only.',
  },
  { id: 'p-splitter', system: 'aero', name: 'Front Splitter + Canards', brand: 'LB × Kaido Works',
    priceNum: 2200, pricePaidNum: 3080, installHrs: 10, image: '/parts/p-diffuser.png',
    rating: 4.9, reviews: 124,
    note: 'Hand-trimmed to the car at Liberty Walk Nagoya. Part of the full Kaido Works kit.',
    whyThisPart: 'Balances the swan-neck wing. Without the splitter the front feels light over 200 km/h.',
    specs: { Lip: '120 mm forward overhang', Canards: '4x hand-laid FRP', Mount: 'Through-bumper studs', Finish: 'Gel coat + paint' },
    performance: 'Balances front-rear downforce. Eliminates the lift the OEM nose gets at speed.',
    install: '10 hrs. Bumper must come off; re-alignment required.',
    thingsToKnow: 'Parking lots will destroy the lip. Drive with intent and it will survive.',
  },
  { id: 'p-skirt', system: 'aero', name: 'Widebody Overfenders + Side Skirts', brand: 'LB × Kaido Works',
    priceNum: 1800, pricePaidNum: 2620, installHrs: 12, image: '/parts/p-skirt.png',
    rating: 5.0, reviews: 102,
    note: 'Visible riveted construction. This is the Kaido Works craftsmanship.',
    whyThisPart: 'The visible rivets are the art. This is what separates LB × Kaido Works from a generic Pandem-style kit.',
    specs: { Construction: 'FRP + 96 hand-set rivets per side', Width: '+75 mm per side', Mount: 'Exposed riveted through-panel' },
    performance: 'Widens the track with the wheels. Without this the FRP fenders would look wrong.',
    install: '12 hrs. The rivets must be hand-placed by a licensed Liberty Walk fitter.',
    thingsToKnow: 'Each rivet hole is drilled through your original fender. Fully committed.',
  },
  { id: 'p-seats', system: 'interior', name: 'Stradia II Low Max Seats', brand: 'Bride',
    priceNum: 3800, pricePaidNum: 4440, installHrs: 3, image: '/parts/p-seats.png',
    rating: 4.7, reviews: 168,
    note: 'Period-correct kaido-racer aesthetic with modern lateral support.',
    whyThisPart: 'Bride Stradia II holds you flat in corners without the hard back of a fixed bucket.',
    specs: { Shell: 'Glass-fibre composite', Material: 'Black gradation fabric', 'Reclining': 'Yes — 50° range', Weight: '11.4 kg / seat' },
    performance: 'Lateral support transforms cornering. You stop bracing with your arms.',
    install: '3 hrs with Bride R32 brackets. Pair with 4-point harnesses.',
    thingsToKnow: 'Use the Bride FIA brackets — never improvise the mount.',
  },
  { id: 'p-wheel', system: 'interior', name: 'Classic 350 Wood Wheel', brand: 'Nardi',
    priceNum: 460, pricePaidNum: 580, installHrs: 1, image: '/parts/p-wheel.png',
    rating: 4.8, reviews: 218,
    note: 'Period-correct wood wheel. Transforms the cabin feel.',
    whyThisPart: 'The kaido-racer wheel — thin rim, polished wood, brass spokes. Pure analogue feel.',
    specs: { Diameter: '350 mm', Dish: '40 mm', Grip: 'Polished mahogany', Spokes: '3-spoke polished aluminium' },
    performance: 'Feel — nothing measurable. Transforms the cabin.',
    install: '1 hr. Airbag delete + Works Bell hub adapter required.',
    thingsToKnow: 'Wood gets oily if you grip with sweaty hands. Keep a microfibre in the car.',
  },
  { id: 'p-tune', system: 'tuning', name: 'F-CON V Pro Standalone ECU', brand: 'HKS',
    priceNum: 1900, pricePaidNum: 2300, installHrs: 5, image: '/parts/p-tune.png',
    rating: 4.6, reviews: 96,
    note: 'Only an HKS-certified RB tuner should map this.',
    whyThisPart: 'A generic standalone will damage the RB26. Pay the specialist — period.',
    specs: { Octane: 'E85 primary / 100 octane fallback', 'Wideband': 'AEM UEGO required', Logging: 'Yes', Backup: 'Stock map retained' },
    performance: 'Final +50 whp on top of the raw hardware gains.',
    install: 'AWD dyno session + road-tune, ~5 hours chair time.',
    thingsToKnow: 'Keep the OEM map as a backup. Do not lose it.',
  },
  { id: 'p-fuel', system: 'fuel', name: 'Sard 740cc + Bosch 044 Fuel System', brand: 'Sard',
    priceNum: 1180, pricePaidNum: 1620, installHrs: 5, image: '/parts/p-fuel.png',
    rating: 4.7, reviews: 118,
    note: 'Required headroom for 480 whp on E85.',
    whyThisPart: 'ARMS turbo airflow outruns stock fuelling. This is the safety net for E85 use.',
    specs: { Injectors: 'Sard 740cc top-feed', 'Flow': '740 cc/min @ 3 bar', Pump: 'Bosch 044 inline', 'Surge tank': 'Stainless 1.5L' },
    performance: 'Invisible upgrade — enables everything else to run safely on E85.',
    install: '5 hrs with surge tank fabrication.',
    thingsToKnow: 'Drain and stabilise the system if storing on E85 for >30 days.',
  },
];

// Tuners / installers per system. Some have logos, some don't (intentional).
// Used in the Parts tab system header "Tune by" block.
export const tunersBySystem = {
  engine: [
    { name: 'Tomei Powered Tokyo', logo: 'https://api.dicebear.com/7.x/initials/svg?seed=TP&backgroundColor=8a0f0f&fontFamily=Arial&fontWeight=700' },
    { name: 'HKS Tokyo',           logo: null },
    { name: 'Mine\'s Motorsport',  logo: 'https://api.dicebear.com/7.x/initials/svg?seed=MM&backgroundColor=000000&fontFamily=Arial&fontWeight=700' },
  ],
  intake: [
    { name: 'HKS Authorised', logo: 'https://api.dicebear.com/7.x/initials/svg?seed=HK&backgroundColor=8a0f0f&fontFamily=Arial&fontWeight=700' },
  ],
  fuel: [
    { name: 'Sard Japan', logo: null },
  ],
  drivetrain: [
    { name: 'OS Giken Specialists', logo: null },
  ],
  suspension: [
    { name: 'HKS Suspension',  logo: 'https://api.dicebear.com/7.x/initials/svg?seed=HS&backgroundColor=000000&fontFamily=Arial&fontWeight=700' },
    { name: 'Cusco Authorised', logo: null },
  ],
  wheels: [
    { name: 'SSR Wheels Japan', logo: 'https://api.dicebear.com/7.x/initials/svg?seed=SSR&backgroundColor=8a0f0f&fontFamily=Arial&fontWeight=700' },
  ],
  brakes: [
    { name: 'Endless Brakes', logo: 'https://api.dicebear.com/7.x/initials/svg?seed=EN&backgroundColor=8a0f0f&fontFamily=Arial&fontWeight=700' },
  ],
  aero: [
    { name: 'Liberty Walk Nagoya', logo: 'https://api.dicebear.com/7.x/initials/svg?seed=LB&backgroundColor=000000&fontFamily=Arial&fontWeight=700' },
    { name: 'Kaido Works Atsugi',  logo: null },
  ],
  exterior: [
    { name: 'Quadrant Racing Livery', logo: null },
  ],
  interior: [
    { name: 'Bride Authorised', logo: null },
    { name: 'Nardi Japan',      logo: 'https://api.dicebear.com/7.x/initials/svg?seed=NA&backgroundColor=000000&fontFamily=Arial&fontWeight=700' },
  ],
  tuning: [
    { name: 'HKS Tuning Center', logo: 'https://api.dicebear.com/7.x/initials/svg?seed=HK&backgroundColor=8a0f0f&fontFamily=Arial&fontWeight=700' },
  ],
};

// Manufacturer-level marketing copy — what a brand's product page or
// catalogue would say about the part.  Used in the Tagged Products tab
// "Product info" section.  Owner-level commentary lives in `note`.
const manufacturerCopy = {
  'p-wheels':    'Forged 3-piece monoblock construction in 6061-T6 aluminium with diamond-cut gloss-black face. Hand-built in Japan. Available in 18×8.5 to 20×13 with custom offset, ET range -50 to +30. Race-tested in Super GT and proven for street weight savings of up to 22% over OEM cast wheels.',
  'p-tires':     'R-compound semi-slick designed for time-attack and track-day duty. Asymmetric tread pattern with a continuous outer rib for high-load cornering. DOT-approved for street use but optimised for warm dry tarmac. Treadwear rating 200, temperature rating A. Operating temperature window 50–95 °C.',
  'p-coilovers': 'Monotube damper with HKS-developed 30-click compression and rebound damping. Designed specifically for the BNR32 Skyline GT-R chassis with ATTESA E-TS torque-split compatibility. Helper springs included. 90 mm continuous lowering range. 60,000 km service interval.',
  'p-arms':      'Hollow 4140 chromoly bars with 3-position adjustable end-links. Front 28mm / rear 24mm. Designed for chassis builders running widebody fitments where the OEM bar fouls flared arches. Cusco polyurethane bushings included; greaseable nylon-lined endlinks for zero NVH.',
  'p-turbo':     'Twin-scroll ball-bearing turbocharger pair developed for the RB26DETT engine. Bolt-on to factory exhaust manifolds with no fabrication. Compressor wheel sized for 480-520 whp on E85 with full supporting modifications. Dyno-proven gain of 200+ whp on a refreshed RB26 short block.',
  'p-intake':    'Aluminium piping kit with sealed airbox and pleated dry-cotton conical filter (re-oilable, 8,000 km service interval). Inspired by HKS late-90s Group A intake design. CARB-exempt EO# pending.',
  'p-exhaust':   '304 stainless steel 3-inch cat-back system with mandrel-bent primaries. Hand-TIG-welded by HKS-certified welders. Includes vibration-damping resonators tuned to eliminate cruise drone while preserving the iconic RB26 top-end howl. CARB-exempt EO# pending.',
  'p-brembo':    '6-piston monoblock fixed caliper, forged 2-piece aluminium body, anodised finish in red, black, or grey. 370×34mm two-piece floating slotted rotor with aluminium hat. Endless MX72 Plus pads pre-installed. Includes Endless braided stainless lines and proportioning hardware. Tested to 700 °C operating temperature.',
  'p-pads':      'Low-metallic friction compound, sintered onto a steel backing plate with chamfered leading edge for cold-bite. Operating temperature window 50–700 °C. Designed for street + light-track duty. Low rotor wear, medium dust output. Bedding-in procedure 300 km street use.',
  'p-wing':      'Single-element swan-neck GT wing with hand-laid fibreglass and gel-coat finish. 1,620 mm span. Mounts via swan-neck through-deck uprights with reinforcing backplates. Each wing is hand-fitted to the car at Liberty Walk Nagoya HQ — never shipped pre-assembled.',
  'p-splitter':  'Hand-laid FRP front splitter with four integrated canards. 120 mm forward overhang. Mounts via through-bumper studs into reinforced subframe brackets. Gel-coat finish ready for paint match. Hand-trimmed during fitment to match each individual car.',
  'p-skirt':     'Hand-laid FRP widebody overfenders + side skirts with 96 polished stainless rivets per side. Adds 75 mm of track per side. Mounts via through-panel rivets directly into the original fender. Each set is hand-trimmed and riveted in place by a licensed Liberty Walk fitter — drilling commits the original bodywork.',
  'p-seats':     'Glass-fibre composite shell with FIA 8855-1999 homologation. Black gradation fabric inserts. Compatible with 4–6 point harnesses via integrated shoulder slots. Weight 11.4 kg per seat (vs 19.2 kg OEM). Reclining mechanism included.',
  'p-wheel':     '350 mm three-spoke polished aluminium frame with hand-finished mahogany rim. 40 mm dish depth. Sold with hub adapter kits for most JDM applications. Hand-finished, period-correct for 1980s and 1990s Japanese sports cars. Weight 1.2 kg.',
  'p-tune':      'Standalone EPROM-mapped ECU developed by HKS specifically for the RB26DETT engine. AEM UEGO wideband datalogging feedback used to optimise fuel + ignition map. Includes warm-up enrichment for cold start, idle stabilisation for ARMS-equipped cars, and an E85-only timing curve.',
  'p-fuel':      'Drop-in Sard 740cc top-feed injectors with matched-flow Bosch 044 inline pump and stainless 1.5L surge tank. 740 cc/min @ 3 bar. Plug-and-play harness for RB26DETT engine management. Tested compatible with HKS, AEM, and Motec ECU strategies. Rated for E85.',
};

// Attach manufacturerInfo to each part for use in the Tagged Products tab.
parts.forEach((p) => { p.manufacturerInfo = manufacturerCopy[p.id] || null; });

// Format a number as a dollar amount string (no decimals).
export const usd = (n) => `$${Number(n).toLocaleString()}`;

// Alternate product listings per part — what other shoppers could buy
// for the same category. Used in the "XX Listings" section of the
// Tagged Products detail view.
const alternates = {
  'p-wheels': [
    { name: 'Volk TE37 Ultra — Bronze',              brand: 'Rays Engineering', price: 4400, image: '/parts/p-wheels.png' },
    { name: 'Work Equip 03 — Black',                 brand: 'Work Wheels', price: 3800, image: '/parts/p-wheels.png' },
    { name: 'BBS LM-R Forged 2-Piece',               brand: 'BBS',         price: 4100, image: '/parts/p-wheels.png' },
    { name: 'SSR Professor SP1R',                    brand: 'SSR',         price: 4200, image: '/parts/p-wheels.png' },
  ],
  'p-brembo': [
    { name: 'Endless Mono 6R Front + Rear Kit',      brand: 'Endless',   price: 6200, image: '/parts/p-brembo.png' },
    { name: 'AP Racing Radi-CAL CP9660',             brand: 'AP Racing', price: 6800, image: '/parts/p-brembo.png' },
    { name: 'Brembo GT-S 6-pot Kit',                 brand: 'Brembo',    price: 5200, image: '/parts/p-brembo.png' },
  ],
  'p-wing': [
    { name: 'Voltex Type-1 Swan-Neck',               brand: 'Voltex',    price: 4200, image: '/parts/p-wing.png' },
    { name: 'APR Performance GTC-300',               brand: 'APR',       price: 1800, image: '/parts/p-wing.png' },
    { name: 'TRA Kyoto / Pandem GT Wing',            brand: 'Pandem',    price: 2400, image: '/parts/p-wing.png' },
  ],
  'p-skirt': [
    { name: 'Pandem Rocket Bunny V3 Kit',            brand: 'Pandem',         price: 4200, image: '/parts/p-skirt.png' },
    { name: 'BN Sports Type-3 Aero',                 brand: 'BN Sports',      price: 3200, image: '/parts/p-skirt.png' },
    { name: 'Origin Lab Stylish Kit',                brand: 'Origin Lab',     price: 2900, image: '/parts/p-skirt.png' },
  ],
  'p-splitter': [
    { name: 'TRA Kyoto Front Splitter',              brand: 'Pandem',    price: 1100, image: '/parts/p-diffuser.png' },
    { name: 'Voltex Carbon Front Lip',               brand: 'Voltex',    price: 1820, image: '/parts/p-diffuser.png' },
  ],
  'p-coilovers': [
    { name: 'Tein Mono Sport Z',                     brand: 'Tein',     price: 2400, image: '/parts/p-coilovers.png' },
    { name: 'Aragosta Type-S 3-Way',                 brand: 'Aragosta', price: 6400, image: '/parts/p-coilovers.png' },
    { name: 'BC Racing BR Series',                   brand: 'BC Racing',price: 1200, image: '/parts/p-coilovers.png' },
  ],
  'p-exhaust': [
    { name: 'Greddy Revolution RS',                  brand: 'Greddy',    price: 2200, image: '/parts/p-exhaust.png' },
    { name: 'Tomei Expreme Ti',                      brand: 'Tomei',     price: 2800, image: '/parts/p-exhaust.png' },
    { name: 'Apexi N1 Evolution Extreme',            brand: 'Apexi',     price: 1800, image: '/parts/p-exhaust.png' },
  ],
};

// Return listings for a given part id. Always includes the part itself
// as the first "current build" listing, followed by alternates.
export const getListingsForPart = (partId) => {
  const part = parts.find((p) => p.id === partId);
  const alts = alternates[partId] || [];
  // Deterministic faux marketplace count (stable across renders)
  const seed = partId.split('').reduce((s, c) => s + c.charCodeAt(0), 0);
  return {
    current: part,
    alternates: alts,
    total: 1 + alts.length + (seed % 14) + 6,
  };
};

export const specs = {
  performance: [
    { label: 'Horsepower',      stock: 276,  built: 480,  unit: 'whp',    max: 700 },
    { label: 'Torque',          stock: 271,  built: 440,  unit: 'lb-ft',  max: 600 },
    { label: '0 – 60 mph',      stock: 5.4,  built: 4.1,  unit: 'sec',    max: 7,   inverse: true },
    { label: '¼ Mile',          stock: 14.0, built: 12.1, unit: 'sec',    max: 16,  inverse: true },
    { label: 'Top Speed',       stock: 156,  built: 188,  unit: 'mph',    max: 220 },
    { label: '60 – 0 Braking',  stock: 132,  built: 108,  unit: 'ft',     max: 160, inverse: true },
  ],
  driving: [
    { label: 'Handling',        stock: 78, built: 96 },
    { label: 'Ride Comfort',    stock: 76, built: 64 },
    { label: 'Steering Feel',   stock: 82, built: 94 },
    { label: 'Acceleration',    stock: 76, built: 95 },
    { label: 'Braking',         stock: 70, built: 96 },
    { label: 'Exhaust Note',    stock: 70, built: 97 },
  ],
  vehicle: {
    Drivetrain: 'ATTESA E-TS AWD',
    Transmission: 'Getrag 5-speed Manual',
    Engine: '2.6L Twin-Turbo Inline-6 (RB26DETT)',
    Induction: 'Tomei ARMS M7960 twin-scroll turbos',
    'Curb Weight': '3,150 lbs',
    Fuel: 'E85 (100 octane fallback)',
  },
  setup: {
    'Wheels (F/R)': '18x10 / 18x11 SSR Professor SP4 — gloss black',
    'Tires (F/R)':  '265/35R18 / 295/30R18 Yokohama Advan A052',
    Suspension:    'HKS Hipermax IV SP coilovers + Cusco sway bars',
    Brakes:        'Endless Mono 6R 6-pot front BBK',
    Alignment:     '-3.0° F / -2.5° R, 0 toe',
    'Ride Height': '90 mm lower than stock',
  },
};

export const comments = [
  {
    id: 1,
    user: 'Ethan Brooks',
    avatar: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=200&q=80',
    time: '3 days ago',
    body: 'Quadrant 13 livery on a Kaido Works R32 is unreal, Stan. The sakura shot is a wallpaper. Did Liberty Walk apply the vinyl in-house?',
    likes: 142,
  },
  {
    id: 2,
    user: 'Priya Verma',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&q=80',
    time: '5 days ago',
    body: 'Planning the Nagoya pilgrimage next year for my BNR34. Any tips on getting on Wataru\'s schedule at Liberty Walk HQ?',
    likes: 96,
  },
  {
    id: 3,
    user: 'Carlos Mendoza',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
    time: '1 week ago',
    body: 'HKS Hipermax IV SP + Tomei ARMS M7960 is the move on a refreshed RB26. What boost target are you running on E85?',
    likes: 64,
  },
];

export const moreBuilds = [
  { id: 1, title: 'BNR34 GT-R — Mine\'s Tribute',  owner: 'Akira Saito',  image: 'https://images.unsplash.com/photo-1614200187524-dc4b892acf16?w=800&q=80', likes: 4240 },
  { id: 2, title: 'Pandem Rocket Bunny S15',       owner: 'Leah Park',    image: 'https://images.unsplash.com/photo-1617531653332-bd46c24f2068?w=800&q=80', likes: 2180 },
  { id: 3, title: 'Hakosuka Skyline Reimagined',   owner: 'Marcus Lee',   image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=800&q=80',  likes: 3502 },
  { id: 4, title: 'Liberty Walk RX-7 FD3S',        owner: 'Jade Okafor',  image: 'https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=800&q=80', likes: 2904 },
];
